import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isWhatfixEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('whatfix'),
)

export default isWhatfixEnabledSelector
